'use strict';

angular.module('ClinicApp').directive('signupForm', function($q, GrowlService, UserService, CurrentUser, OCAnalyticsUtil, OCDomUtil) {
  return {
    restrict: 'A',
    templateUrl: '/views/directives/_signup-form.html',
    scope: {
      success: '&',
      successButtonText: '=',
      emailProvided: '=',
    },
    link: function($scope) {
      $scope.user = {};

      if ($scope.emailProvided) {
        $scope.user.email = $scope.emailProvided;
      }

      $scope.signup = function() {
        if (!$scope.user.password || $scope.user.password !== $scope.user.passwordConfirm) {
          GrowlService.error('Passwords provided do not match.');
          return $q.reject();
        }
        return UserService.signup(
          $scope.user.email,
          $scope.user.password,
          $scope.user.firstName,
          $scope.user.lastName,
        )
          .then(() => {
            CurrentUser.update(() => {
              OCAnalyticsUtil.setUserInfo(CurrentUser.getUser());
              $scope.success();
            });
          })
          .catch(() => {
            OCDomUtil.setFocusOn('signup-form-email');
          });
      };
    },
  };
});
